
export class DesaparecidoCompDto {
	numoriginal: string;
	fecha_ingreso: string;
	hora_ingreso: string;
	nro_registro: string;
	codigo: string;
	folio: string;
	distrito: string;
	macrodistrito: string;
	observacion: string;
	descripcion_aparicion: string;
	tiempo_desaparicion: string;
	zona: string;
	direccion: string;
	policia_complemento: string;
	orden: string;
	estado: string;
	fecha_recepcion: string;	
}
